import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-img-slider',
  templateUrl: './img-slider.component.html',
  styleUrls: ['./img-slider.component.css']
})
export class ImgSliderComponent implements OnInit {
  private imgUrls: string[];
  private captions: string[];
  private current = 0;
  private secondsActive = 0;
  private offsets: any;
  private viewStates: any;
  private slider: ImgSliderComponent;

  constructor() {
    this.imgUrls = [];
    this.captions = [];

    this.offsets = {
      'view1' : 1,
      'view2' : 0,
      'view3' : -1
    };

    this.viewStates = {
       'view1' : 'onRight',
       'view2' : 'active',
       'view3' : 'onLeft'
    };

    this.slider = this;
  }

  ngOnInit() {
    const slider = this;

    slider.imgUrls = [
      'assets/images/img-slider/1.jpg',
      'assets/images/img-slider/2.jpg',
      'assets/images/img-slider/3.jpg',
      'assets/images/img-slider/4.jpg',
      'assets/images/img-slider/5.jpg',
      'assets/images/img-slider/6.jpg'
    ];

    window.setInterval(function() {
      slider.secondsActive++;
      if (slider.secondsActive >= 6) {
        slider.goRight();
      }
    }, 1000);
  }

  goRight() {
    this.secondsActive = 0;

    let temp = this.offsets.view1;
    this.offsets.view1 = this.offsets.view2;
    this.offsets.view2 = this.offsets.view3;
    this.offsets.view3 = temp;

    if (this.current + 1 >= this.imgUrls.length) {
      this.current = 0;
    } else {
      this.current++;
    }

    temp = this.viewStates.view1;
    this.viewStates.view1 = this.viewStates.view2;
    this.viewStates.view2 = this.viewStates.view3;
    this.viewStates.view3 = temp;
  }

  goLeft() {
    this.secondsActive = 0;

    let temp = this.offsets.view3;
    this.offsets.view3 = this.offsets.view2;
    this.offsets.view2 = this.offsets.view1;
    this.offsets.view1 = temp;

    if (this.current - 1 < 0) {
      this.current = this.imgUrls.length - 1;
    } else {
      this.current--;
    }

    temp = this.viewStates.view3;
    this.viewStates.view3 = this.viewStates.view2;
    this.viewStates.view2 = this.viewStates.view1;
    this.viewStates.view1 = temp;
  }

  getCurrent(offset) {
    if (this.current + offset < 0) {
      return this.imgUrls.length - 1;
    }

    if (this.current + offset >= this.imgUrls.length) {
      return 0;
    }

    return this.current + offset;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/home/img-slider/img-slider.component.ts